import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../services/api.service';
import { buildHttpParams } from '../utils';
import { Dealer } from './dealers.model';

@Injectable({
  providedIn: 'root',
})
export class DealersService {
  private readonly _baseUrl: string = 'dealers/';

  constructor(private _apiService: ApiService) {}

  list(q = {}): Observable<any> {
    const params = buildHttpParams(q);
    return this._apiService.get(this._baseUrl, params);
  }

  post(reqBody: any): Observable<any> {
    return this._apiService.post(this._baseUrl, reqBody);
  }

  delete(id: string): Observable<any> {
    return this._apiService.delete(`${this._baseUrl}${id}/`);
  }

  update(id: string, reqBody: any): Observable<any> {
    return this._apiService.put(`${this._baseUrl}${id}/`, reqBody);
  }

  create_mappings(reqBody: any): Observable<any> {
    return this._apiService.post('mappings/create-mappings/', reqBody);
  }

  lighter_list(): Observable<Dealer[]> {
    return this._apiService.get(this._baseUrl + 'lighter_list');
  }

  insights(id: string): Observable<any> {
    return this._apiService.get(`${this._baseUrl}${id}/insights/`);
  }

  getDealerAreas(): Observable<string[]> {
    return this._apiService.get(`${this._baseUrl}dealer_areas/`);
  }

  exportDealerList(
    filters: {
      search?: string;
      area?: string;
      employee?: string;
      firm_type?: string;
    } = {}
  ): Observable<Blob> {
    const query: Record<string, string> = {};
    if (filters.search) query['search'] = filters.search;
    if (filters.area) query['area'] = filters.area;
    if (filters.employee) query['employee'] = filters.employee;
    if (filters.firm_type) query['firm_type'] = filters.firm_type;
    const params = buildHttpParams(query);
    return this._apiService.getBlob(`${this._baseUrl}export/`, params);
  }

  exportOrders(id: string): Observable<Blob> {
    return this._apiService.getBlob(`${this._baseUrl}${id}/export-orders/`);
  }

  exportPayments(id: string): Observable<Blob> {
    return this._apiService.getBlob(`${this._baseUrl}${id}/export-payments/`);
  }

  exportVisits(filters: {
    year?: number | null;
    month?: number | null;
    date?: string;
    start_date?: string;
    end_date?: string;
    dealer?: string;
    employee?: string;
  }): Observable<Blob> {
    const query: Record<string, string> = {};
    if (filters.year) query['year'] = filters.year.toString();
    if (filters.month) query['month'] = filters.month.toString();
    if (filters.date) query['date'] = filters.date;
    if (filters.start_date) query['start_date'] = filters.start_date;
    if (filters.end_date) query['end_date'] = filters.end_date;
    if (filters.dealer) query['dealer'] = filters.dealer;
    if (filters.employee) query['employee'] = filters.employee;
    const params = buildHttpParams(query);
    return this._apiService.getBlob(`${this._baseUrl}export-visits/`, params);
  }
}
